// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"84dc062f","222":"1f606ae5","373":"d10e77f6","378":"f5fb8b76","399":"97842256","409":"c9a4f4cc","423":"e0b6caf7","537":"def095fb","657":"2cda7d30","663":"5582d03b","856":"979d6348","980":"83ab976a"}[chunkId] + ".chunk.js";
};